import React from 'react';
import './Event_about.css';

const Event_about = () => {
    const state = {
        FourKeys_item: [
            {
                title: 'ChatGPT Plugin Development',
                topics: [
                    'The latest developments in ChatGPT Plugin technology and its potential for future growth',
                    'Customizing the ChatGPT Plugin for specific applications or industries',
                    'Best practices for integrating the ChatGPT Plugin into existing software',
                    'Using the ChatGPT Plugin to improve customer service and support',
                ],
            },
            {
                title: 'Code Assistance',
                topics: [
                    'Using ChatGPT plugin to assist with code completion and generation',
                    `Enabling the plugin to suggest best practices and coding standards for the developer's project`,
                    'Using the plugin to perform code reviews and identify potential errors or vulnerabilities in the code',
                ],
            },
            {
                title: 'ChatGPT Plugin Best Practices',
                topics: [
                    'Best practices for ensuring user privacy and security with the ChatGPT Plugin',
                    `Incorporating user-generated content to improve the ChatGPT Plugin's performance`,
                    'Deploying ChatGPT Plugin on cloud platforms',
                    'Implementing secure API authentication for ChatGPT Plugin',
                    'Techniques for monitoring and scaling ChatGPT Plugin in production',
                ],
            },
            {
                title: 'Personalization and Customization',
                topics: [
                    'Allowing developers to customize the ChatGPT plugin to fit their specific needs and preferences',
                    `Enabling the plugin to learn from the developer's coding patterns and suggest personalized solutions`,
                    'Adding support for different programming languages and frameworks to the plugin',
                ],
            },
        ],
    };

    const renderGetReady = (item, i) => {
        return (
            <div className="getReady_item" key={`getReady_item-${i}`}>
                <div className='getReady_item--title_block'>
                    <h3 className='getReady_item--title'>{item.title}</h3>
                </div>
                <ul className='getReady_ul'>
                    {item.topics.map(item => <li className='getReady_li p2' key={`getReady_li-${i + item}`}><span>[]</span> {item}</li>)}
                </ul>
            </div>
        );
    };

    return (
        <div className='getReady_wrap'>
            <div className='container getReady'>
                <h2 className='getReady_title colorful'>What is the event about?</h2>
                <div className='getReady_block'>
                    {state.FourKeys_item.map((item, i) => renderGetReady(item, i))}
                </div>
            </div>
        </div>
    );
};

export default Event_about;